<template>
  <div class="modal-card addUser">
    <div class="modal-card-head">
      <div class="modal-card-title">{{ Operation }} User</div>
    </div>
    <div class="modal-card-body">
      <div class="columns">
        <div class="column">

          <b-field label="First name">
            <b-input placeholder="First Name" type="text" v-model="user.FirstName"></b-input>
          </b-field>

          <b-field label="Last name">
            <b-input placeholder="Last Name" type="text" v-model="user.LastName"></b-input>
          </b-field>

          <b-field label="Organization">
            <b-input placeholder="Organization's Name" type="text" v-model="user.OrganizationName"></b-input>
          </b-field>

          <b-field label="Organization Address">
            <b-input placeholder="Organization's Address" type="text" v-model="user.OrganizationAddress"></b-input>
          </b-field>

          <b-field v-if="!$store.getters.isAdmin" label="Email" :type="{ 'is-danger': mustMatch }" :message="{ 'This domain must match your own.': mustMatch }">
            <b-input :placeholder="$store.getters.user.Username.substring($store.getters.user.Username.lastIndexOf('@'))" type="email" v-model="user.Email"></b-input>
          </b-field>

          <b-field v-if="$store.getters.isAdmin" label="Email">
            <b-input placeholder="Email" type="email" v-model="user.Email"></b-input>
          </b-field>

          <b-field label="Expires on">
            <b-datepicker expanded v-model="user.ExpiresOn"></b-datepicker>
            <span class="control">
              <b-button type="is-primary" label="X" @click="user.ExpiresOn = null" />
            </span>
          </b-field>

        </div>
        <div class="column">
          <b-field label="Roles">
            <b-taginput placeholder="Select the User's Roles"
                        autocomplete
                        type="is-primary"
                        field="Name"
                        v-model="user.Roles"
                        :data="filteredRoles"
                        @typing="filterRoles"
                        open-on-focus>
            </b-taginput>
          </b-field>

          <RoleDescriptions class="my-2"></RoleDescriptions>


          <h3>Groups</h3>
          <span v-if="$store.getters.isAdmin">If you would like to create a group, follow <a @click="goToGroupAdmin">this link.</a></span>



          <b-field label="CTC Groups">
            <b-taginput placeholder="Select the User's Groups"
                        autocomplete
                        type="is-primary"
                        field="Name"
                        v-model="user.Groups"
                        :data="filteredGroups"
                        @typing="filterGroups"
                        open-on-focus
                        v-show="!Group">
            </b-taginput>
            <div class="breathe-sm" v-if="Group">
              <span><b>{{Group.Name}}</b></span>
            </div>
          </b-field>

          <b-field label="ACC Group" message="Changing a user's group will result in the loss of aircraft and portifolios" v-show="$store.getters.isAdmin">
            <b-select v-model="user.CalculatorGroup" placeholder="Select a group">
              <option :value="null">No Group</option>
              <option v-for="group in CalculatorGroups" :value="group.Id">{{group.Name}}</option>
            </b-select>
          </b-field>

          <div class="breathe">
            <b-field>
              <b-checkbox v-model="user.IsGroupManager">Is a Group Manager?</b-checkbox>
            </b-field>
            <b-field v-if="$store.getters.isAdmin">
              <b-checkbox v-model="user.Disabled">Disable the user from logging in?</b-checkbox>
            </b-field>
            <b-field>
              <b-checkbox v-model="user.IsHidden">Hide user?</b-checkbox>
            </b-field>
            <b-field>
              <b-checkbox v-model="user.IsACID">ACID document access</b-checkbox>
            </b-field>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-card-foot">
      <b-button class="yellow-button" @click="$parent.close()">Cancel</b-button>
      <b-button class="is-primary" @click="addEditUser">Submit</b-button>
    </div>
  </div>
</template>

<script>
  import RoleDescriptions from '@/components/admin/users/roleDescriptions.vue';

  export default {
    components: {
      RoleDescriptions
    },
    data() {
      return {
        user: {
          Email: ""
        },
        filteredGroups: [],
        filteredRoles: [],
        Roles: [],
        Groups: [],
      }
    },
    props: {
      Model: Object,
      Group: Object
    },
    computed: {
      Operation() {
        if (this.Model.Id)
          return "Edit";
        else
          return "Add";
      },
      CalculatorGroups() {
        return this.Groups.filter(g => g.CountryId == null);
      },
      mustMatch() {
        if (!this.$store.getters.isAdmin && this.Operation == "Add") {
          if (this.$store.getters.user.Username.substring(this.$store.getters.user.Username.lastIndexOf('@')) == this.user.Email.substring(this.user.Email.lastIndexOf('@')))
            return false;
          else
            return true;
        }
      }
    },
    methods: {
      goToGroupAdmin() {
        this.$parent.close();
        this.$router.push("/admin/groups");
      },
      addEditUser() {
        if (this.user.FirstName && this.user.LastName && this.user.Roles) {
          this.addUserToDb().then(r => {
            if (r)
              this.$parent.close();
          });
        } else {
          this.$buefy.notification.open({
            duration: 4000,
            message: "Please fill out all fields",
            type: 'is-danger',
          })
        }
      },
      filterGroups(text) {
        this.filteredGroups = this.Groups.filter((option) => {
          return option
            .Name
            .toString()
            .toLowerCase()
            .indexOf(text.toLowerCase()) >= 0;
        })
      },
      filterRoles(text) {
        this.filteredRoles = this.Roles.filter((option) => {
          return option
            .Name
            .toString()
            .toLowerCase()
            .indexOf(text.toLowerCase()) >= 0;
        })
      },
      openBadNotification(message) {
        this.$buefy.notification.open({
          duration: 4000,
          message: message,
          type: 'is-danger',
        });
      },
      addUserToDb() {
        this.user.CreatorId = this.$store.getters["user"].Id;
        this.user.Name = this.user.FirstName + " " + this.user.LastName;
        if (this.user.ExpiresOn)
          this.user.ExpiresOn = new Date(this.user.ExpiresOn);
        else
          this.user.ExpiresOn = null;
        if (this.Operation == "Add") {
          return this.$http.post("api/user/register", this.user)
            .then(resp => {
              if (resp.data == "Invalid Username") {
                this.openBadNotification("Please enter a correct email.");
              } else if (resp.data == "User already exists") {
                this.openBadNotification("This user already exists based on their email. Please recheck records.");
              } else if (resp.data == "Failed") {
                this.openBadNotification("An unhandled error occurred. Please try again later.");
              } else if (resp.data == "Success") {
                this.$emit('refreshUsers', this.user);
                this.$buefy.notification.open({
                  duration: 4000,
                  message: "User added successfully",
                  type: 'is-success',
                });
                return true;
              } else {
                this.$buefy.notification.open({
                  duration: 4000,
                  message: "An error occurred. Please try again later.",
                  type: 'is-danger',
                });
              }
              return false;
            })
        } else {
          return this.$http.post("api/user/update", this.user)
            .then(resp => {
              if (resp.data == "Invalid Username") {
                this.openBadNotification("Please enter a correct email.");
              } else if (resp.data == "Failed") {
                this.openBadNotification("An unhandled error occurred. Please try again later.");
              } else if (resp.data == "Success") {
                this.$emit('refreshUsers', this.user);
                this.$buefy.notification.open({
                  duration: 4000,
                  message: "User editted successfully",
                  type: 'is-success',
                });
                return true;
              } else {
                this.$buefy.notification.open({
                  duration: 4000,
                  message: "An error occurred. Please try again later.",
                  type: 'is-danger',
                });
              }
              return false;
            })
        }


      }
    },
    async created() {
      var t1 = this.$http.get("api/roles")
        .then(resp => {
          this.Roles = resp.data;
        }).catch(err => {
          console.error(err);
        });

      var t2 = this.$http.get("api/group")
        .then(resp => {
          this.Groups = resp.data;
        }).catch(err => {
          console.error(err);
        });

      await Promise.all([t1, t2]);

      this.filteredGroups = this.Groups;
      this.filteredRoles = this.Roles;
      this.user = this.Model;

      if (this.Group) {
        this.user.Groups = [this.Group];
        this.user.CalculatorGroup = this.Group;
      }

      if (this.Model.ExpiresOn) {
        this.user.ExpiresOn = new Date(this.user.ExpiresOn);
      }
    }
  }
</script>

<style>


  .addUser {
    overflow: visible !important;
    width: 960px !important;
  }

  /*.addUser .modal-card-body {
      overflow: visible !important;
    }*/
</style>
